export const STATIC_MODAL_CLASSNAME = 'modal';

export const CLOSING_REASON = {
  OVERLAY: 'overlay',
  CLOSER: 'closer',

  HEADER_BUTTON: 'header',
  PRIMARY_BUTTON: 'primary',
  SECONDARY_BUTTON: 'secondary',

  ESCAPE_KEY: 'esc',
};
